// extracted by mini-css-extract-plugin
export default {"LinkOfferCreate":"styles_LinkOfferCreate__7epCN","LinkOfferCreate_form":"styles_LinkOfferCreate_form__QaWY1","info":"styles_info__D+EuL","list":"styles_list__sSJkt"};